import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";

const QUESTIONS = [
  {
    id: 1,
    cat: "Generative AI",
    text: "Do your employees use ChatGPT, Claude, Copilot, or other AI assistants for work?",
    answers: ["Yes — across multiple teams", "Yes — informally / shadow IT", "No", "Not sure"],
  },
  {
    id: 2,
    cat: "AI in Hiring",
    text: "Does any part of your hiring process use AI to screen candidates, rank applications, or analyze interviews?",
    answers: ["Yes", "No", "Considering it", "Not sure"],
  },
  {
    id: 3,
    cat: "AI in Operations",
    text: "Do you use AI for anything involving customer data — recommendations, support automation, churn prediction, content personalization?",
    answers: ["Yes", "No", "Not sure"],
  },
];

const QuestionCard = ({ q, index }) => (
  <Reveal delay={index * 90}>
    <article
      data-testid={`preview-card-${q.id}`}
      className="relative rounded-2xl border bg-white p-6 md:p-7"
      style={{ borderColor: "var(--line)" }}
      aria-hidden="true"
    >
      <span
        data-testid={`preview-card-${q.id}-badge`}
        className="absolute right-4 top-4 rounded-full border px-2 py-0.5 text-[10px] font-semibold tracking-[0.18em] uppercase"
        style={{ color: "var(--muted-2)", borderColor: "var(--line)" }}
      >
        Preview
      </span>

      <p className="text-[11px] font-semibold tracking-[0.18em] uppercase" style={{ color: "var(--muted-2)" }}>
        Q{q.id} of 20 · {q.cat}
      </p>

      <h4
        data-testid={`preview-card-${q.id}-question`}
        className="mt-3 pretty text-[17px] font-semibold leading-snug tracking-tight"
        style={{ color: "var(--ink)" }}
      >
        {q.text}
      </h4>

      <div className="mt-5 grid grid-cols-1 gap-2">
        {q.answers.map((a, i) => (
          <button
            key={i}
            type="button"
            tabIndex={-1}
            data-testid={`preview-card-${q.id}-answer-${i}`}
            className="answer-pill text-left"
          >
            {a}
          </button>
        ))}
      </div>
    </article>
  </Reveal>
);

export const PreviewAudit = () => (
  <div data-testid="preview-audit" className="mt-12">
    <Reveal>
      <p className="eyebrow" data-testid="preview-eyebrow">
        Preview · What the audit asks
      </p>
    </Reveal>
    <Reveal delay={60}>
      <h3
        data-testid="preview-headline"
        className="display-h2 balance mt-3 text-2xl sm:text-3xl md:text-[34px]"
        style={{ color: "var(--ink)" }}
      >
        A quick taste of the real audit.
      </h3>
    </Reveal>
    <Reveal delay={120}>
      <p
        data-testid="preview-sub"
        className="pretty mt-3 max-w-2xl text-[15.5px]"
        style={{ color: "var(--muted)" }}
      >
        Three sample questions below. The full audit covers 20 questions across 5 categories — generative AI, hiring,
        operations, customer-facing systems, and decisioning.
      </p>
    </Reveal>

    <div className="mt-8 grid gap-5 lg:grid-cols-3" data-testid="preview-grid">
      {QUESTIONS.map((q, i) => (
        <QuestionCard key={q.id} q={q} index={i} />
      ))}
    </div>

    <div className="mt-8">
      <Link
        to="/assessment"
        data-testid="preview-cta"
        className="inline-flex items-center gap-2 text-[15px] font-semibold link-u"
        style={{ color: "var(--ink)" }}
      >
        <span>Take the full audit</span>
        <ArrowRight className="h-4 w-4" strokeWidth={2.25} aria-hidden="true" />
      </Link>
    </div>
  </div>
);

export default PreviewAudit;
